import type { FilterParams } from '../components/ListView/filterConfig'

export const COLUMNS_STORAGE_PREFIX = 'kistill-list-view-columns-'
export const FILTERS_STORAGE_PREFIX = 'kistill-list-view-filters-'

export type ColumnVisibilityState = Record<string, boolean>

export function getColumnVisibility(
  type: string,
  defaults: ColumnVisibilityState
): ColumnVisibilityState {
  if (!type || typeof window === 'undefined') return { ...defaults }
  try {
    const raw = window.localStorage.getItem(COLUMNS_STORAGE_PREFIX + type)
    const saved = raw ? (JSON.parse(raw) as Record<string, boolean>) : {}
    return { ...defaults, ...saved }
  } catch (err) {
    console.warn(
      '[listViewStorage] getColumnVisibility failed for type',
      type,
      err
    )
    return { ...defaults }
  }
}

export function setColumnVisibility(
  type: string,
  value: ColumnVisibilityState
): void {
  if (!type || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(
      COLUMNS_STORAGE_PREFIX + type,
      JSON.stringify(value)
    )
  } catch (err) {
    console.warn(
      '[listViewStorage] setColumnVisibility failed for type',
      type,
      err
    )
  }
}

export function getFilterParams(type: string): FilterParams | null {
  if (!type || typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(FILTERS_STORAGE_PREFIX + type)
    return raw ? (JSON.parse(raw) as FilterParams) : null
  } catch (err) {
    console.warn(
      '[listViewStorage] getFilterParams failed for type',
      type,
      err
    )
    return null
  }
}

export function setFilterParams(type: string, params: FilterParams): void {
  if (!type || typeof window === 'undefined') return
  try {
    window.localStorage.setItem(
      FILTERS_STORAGE_PREFIX + type,
      JSON.stringify(params)
    )
  } catch (err) {
    console.warn(
      '[listViewStorage] setFilterParams failed for type',
      type,
      err
    )
  }
}
